import cx from "classnames";

const benefitIcons: {
  [key: string]: string;
} = {
  AmazonPrime: "/prime.png",
  DeezerPremium: "/deezer.png",
  DeezerNow: "/deezer-now.png",
  DisneyPlus: "/disney+.png",
  YoutubePremium: "/youtube.png",
  HBOMax: "/HBOMax.png",
  Paramount: "/paramount+.png",
  GloboPlay: "/globoPlayBBB.png",
  PrimeCelular: "/prime-mobile.png",
  Audiobooks: "/books.png",
  EnsinahPremium: "/ensinah.png",
  Babel: "/babbel.png",
  Bancah: "/bancah.png",
  Cloud: "/cloud.png",
  Gestao: "/gestao.png",
  TimSeguranca: "/timSeguranca.png",
  Seguranca: "/seguranca.png",
  Fluid: "/fluid.png",
  Mulheres: "/mulheres.png",
  EnsinahEquilibrah: "/equilibrah.png",
  DescontoExtra: "/descontoExtra.png",
  Netflix: "/Netflix.png",
  FoodBalanceLight: "/foodBalance.png",
  MaisRecompensasLight: "/maisRecompensas.png",
  itGame: "/itGame.png",
};

type ChoiceBenefitsProps = {
  label: string;
  component?: string;
  hasAds?: boolean;
};

const ChoiceBenefits = ({ label, component, hasAds }: ChoiceBenefitsProps) => {
  const whichSubLabel =
    component == "HBOMax" ? " Básico com anúncios" : " Padrão com anúncios";
  return (
    <div
      className={cx(
        "mt-2 flex items-center text-base text-gray-700",
        component === "PrimeCelular" && "ml-[-14px]"
      )}
    >
      <img
        src={benefitIcons[component!] || "/check.svg"}
        alt={label}
        width={component === "PrimeCelular" ? 61 : 24}
        className="rounded"
      />
      <span className={cx(component === "PrimeCelular" ? "ml-[6px]" : "ml-2")}>
        <strong className="font-normal">{label}</strong>
        <span className="font-thin">{!!hasAds && whichSubLabel}</span>
      </span>
    </div>
  );
};

export default ChoiceBenefits;
